import { Alert, Button, Group } from '@mantine/core';
import { IconUserExclamation } from '@tabler/icons-react';
import { trpc } from '../lib/trpc';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Sticky banner shown when the current session is an impersonation. Clicking
 * "Exit impersonation" calls tRPC `auth.endImpersonation` which restores the
 * original user's session and clears the wj_impersonated_by cookie.
 */
export function ImpersonationBanner() {
  const me = trpc.auth.me.useQuery();
  const endImpersonation = trpc.auth.endImpersonation.useMutation({
    onSuccess: () => {
      window.location.href = '/vendor/team';
    },
  });

  return (
    <AnimatePresence>
      {me.data?.isImpersonating && (
        <motion.div
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 220, damping: 24 }}
          style={{ position: 'sticky', top: 0, zIndex: 1000 }}
        >
          <Alert
            color="orange"
            icon={<IconUserExclamation size={18} />}
            radius={0}
            title="You are impersonating another user"
          >
            <Group justify="space-between" align="center">
              <span>Session is read-write under the target user's permissions.</span>
              <Button
                size="xs"
                variant="filled"
                color="orange"
                onClick={() => endImpersonation.mutate()}
                loading={endImpersonation.isPending}
              >
                Exit impersonation
              </Button>
            </Group>
          </Alert>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
